import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=567f086e&scoped=true"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
import style0 from "./Update.vue?vue&type=style&index=0&id=567f086e&prod&scoped=scoped&lang=css"
import style1 from "./Update.vue?vue&type=style&index=1&id=567f086e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567f086e",
  null
  
)

export default component.exports